import { format, utcToZonedTime } from 'date-fns-tz';
 
export const includeTime = (url: string, isHourly: boolean): string => {
  const date = new Date();
  const timeZone = "America/Toronto";
  const localTime = utcToZonedTime(date, timeZone);
 
  const dateString = format(localTime, 'yyyy-MM-dd', { timeZone });
  const timeString = format(localTime, 'HH:mm', { timeZone });
 
  return `${url}?name=All&dateTime=${dateString}%20${timeString}:00&${isHourly ? 'hours=24' : 'days=90'}`;
};
 
export const processResponseData = (responseData: any[], isHourly: boolean, services: any): any[] => {
  if (isHourly) {
    responseData = responseData.map((item) => {
      if (item.data && item.data[0] && Object.keys(item.data[0]).length === 25) {
        const { [Object.keys(item.data[0])[0]]: _, ...rest } = item.data[0];
        item.data[0] = rest;
      }
      return item;
    });
  }
 
  const serviceOrder = Object.keys(services);
  return responseData.sort((a, b) => serviceOrder.indexOf(a.API) - serviceOrder.indexOf(b.API));
};
 
export const setSessionStorage = (key: string, data: any, isHourly: boolean): void => {
  let expiration = new Date();
  isHourly ? expiration.setMinutes(expiration.getMinutes() + 5) : expiration.setHours(expiration.getHours() + 60);
 
  sessionStorage.setItem(
    key,
    JSON.stringify({
      data,
      expiration: expiration.getTime(),
    })
  );
};

export const formatXML = (xml: string, tab: string = '\t'): string => {
  let formatted = '';
  let indent = '';

  xml.split(/>\s*</).forEach((node) => {
    if (node.match(/^\/\w/)) {
      indent = indent.substring(tab.length);
    }
    formatted += `${indent}<${node}>\r\n`;
    if (node.match(/^<?\w[^>]*[^/]$/)) {
      indent += tab;
    }
  });

  return formatted.trim().slice(1, -1);
};


export const cleanDetailsLink = (link="") =>
link
  .toLowerCase()
  .replaceAll("–", "")
  .replaceAll(" ", "-")
  .replaceAll(")", "")
  .replaceAll("(", "")
  .replaceAll("/", "")